import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    preDefinedWidgets: [
    {
        id: "section",
        label: "Section",
        formType: "sectionForm",
        iconId: "edit",
    },
    {
        id: "sub-section",
        label: "Sub-Section",
        formType: "subSectionForm",
        iconId: "edit",
    },
    {
        id: "input",
        label: "Text",
        span: 24,
        formType: "inputForm",
        iconId: "fontSize"
    },
    {
        id: "textArea",
        label: "Text Area",
        span: 24,
        formType: "textAreaForm",
        iconId: "alignLeft"
    },
    {
        id: "checkbox",
        label: "Checkbox",
        span: 24,
        formType: "checkboxField",
        iconId: "checkSquare"
    },
    {
        id: "switch",
        label: "Switch",
        formType: "switchForm",
        iconId: "switch"
    },
    {
        id: "select",
        label: "Select List",
        formType: "selectListForm",
        iconId: "unorderedList"
    },
    {
        id: "date",
        label: "Date",
        formType: "dateForm",
        span: 8,
        iconId: "calendar"
    },
    {
        id: "number",
        label: "Number",
        formType: "numberForm",
        span: 8,
        iconId: "number"
    },
    {
        id: "upload",
        label: "Attachment",
        formType: "uploadForm",
        span: 8,
        iconId: "paperClip"
    },
    {
        id: "address",
        label: "Address",
        span: 24,
        formType: "addressForm",
        iconId: "home",
    },
    {
        id: "link",
        label: "Link",
        span: 24,
        formType: "linkForm",
        iconId: "link",
    },
    {
        id: "static-content",
        label: "Static Content",
        formType: "staticContentForm",
        iconId: "profile"
    },
    {
        id: "image",
        label: "Image",
        formType: "imageForm",
        iconId: "fileImage"
    },
    {
        id: "table",
        label: "Table",
        formType: "tableForm",
        iconId: "table"
    },
    ],
    userDefinedWidgets: [],
    organizationalWidgets: [],
    selectedWidget: {},
    elements: []
};
  
const widgetsSlice = createSlice({
    name: "widgets",
    initialState,
    // action: UnknownAction,
    reducers: {
        setDefinedWidgets: (state, { payload }) => {
            const { data, callback } = payload
            state.userDefinedWidgets = data;
            if(callback){
                callback(data)
            }
        },
        setOrganizationalWidgets: (state, { payload }) => {
            state.organizationalWidgets = payload.data;
        },
        setSelectedWidget: (state, { payload }) => {
            state.selectedWidget = payload
        },
        setElements: (state, { payload }) => {

            state.elements = [...payload]
        }
    }
});

export const { setDefinedWidgets, setOrganizationalWidgets, setSelectedWidget, setElements } = widgetsSlice.actions;
export default widgetsSlice.reducer;